<template lang='pug'>
  pre.extra(v-if='extraText' v-text='extraText')
</template>

<script>
export default {
  props: {
    extra: Object,
  },
  data() {
    return {
      platformId: this.$app.getPlatformId(),
    }
  },
  computed: {
    extraText() {
      if (this.platformId != 2 && this.platformId != 3 && this.platformId !=4) return ''
      var pstatuses = {
        1: '未启动',
        2: '在研',
        3: '完成',
        4: '暂停',
        5: '终止',
      }
      if (this.platformId==2 || this.platformId==3) {
        return (this.extra.oname+'--'+this.extra.dname+'--'+this.extra.projectName+'    受理/备案/批件号：'+(this.extra.code ? this.extra.code :this.extra.projectCode)+'    项目在状态：'+ pstatuses[this.extra.pstatus]+'    申办方：'+ (this.extra.sname ? this.extra.sname : '无') +'    PI：'+ (this.extra.pname ? this.extra.pname : '无'))
      } else {
          return (this.extra.projectName+'    受理/备案/批件号：'+(this.extra.code ? this.extra.code : this.extra.projectCode)+'    项目在状态：'+pstatuses[this.extra.pstatus]+'    申办方：' + (this.extra.sname ? this.extra.sname : '无') +'    PI：'+ (this.extra.pname ? this.extra.pname : '无'))
      }
    }

  },
  mounted() {
    // console.log('platformId', this.platformId)
  }
}
</script>

<style lang='stylus' scoped>
pre.extra
  background-color #edffff
  border-bottom 1px solid #dbf5f3
  font-family inherit
  font-size 14px
  line-height 1.6
  margin -10px -10px 0
  padding 16px 20px 16px 64px
  white-space pre-wrap
</style>



// WEBPACK FOOTER //
// src/components/detail-extra.vue